import React from "react";

export interface ScoreBadgeProps {
  score: number;
  max: number;
  size?: "sm" | "lg";
  className?: string;
}

export function ScoreBadge({
  score,
  max,
  size = "sm",
  className = "",
}: ScoreBadgeProps) {
  const ratio = score / max;
  const color =
    ratio >= 0.7
      ? "var(--color-success)"
      : ratio >= 0.4
      ? "var(--color-warning)"
      : "var(--color-error-text)";

  const sizeClass =
    size === "lg" ? "text-[16px] px-3 py-1" : "text-[12px] px-2 py-0.5";

  return (
    <span
      className={`inline-block font-bold rounded-full ${sizeClass} ${className}`}
      style={{
        backgroundColor: `${color}15`,
        color,
        border: `1px solid ${color}30`,
      }}
    >
      {score}/{max}
    </span>
  );
}
